import { Box } from '@chakra-ui/react';
import { CbColorBanner } from 'ui/components/CbColorBanner';
import { CbMobileFilterDateRange } from 'ui/components/CbMobileFilterDateRange';
import { CbSelect } from 'ui/components/CbSelect';
import { getGamesFilterOptions } from '../../../types';
import { useIsEmbedded } from 'providers';
export interface HeaderProps {
  activeFilter: string;
  isMobile: boolean;
  onFilterChange: (value: string) => void;
}
export const Header = ({
  activeFilter,
  isMobile,
  onFilterChange
}) => {
  const {
    isEmbedded: isEmbeddedMode
  } = useIsEmbedded();
  const filterOptions = getGamesFilterOptions();
  const handleFilterChange = (option: string | {
    value: string;
    name: string;
  }) => {
    const value = typeof option === 'string' ? option : option.value;
    onFilterChange(value);
  };
  const selectedOption = filterOptions.find(opt => opt.value === activeFilter);
  return <CbColorBanner background={isEmbeddedMode ? 'spyro.100' : 'gradient.darkModeBanner'} componentColor={isEmbeddedMode ? 'text.primaryDark' : 'white'} title="Game Center" rightElement={<Box>
          {isMobile ? <CbMobileFilterDateRange colorScheme={isEmbeddedMode ? 'blackAlpha' : 'whiteAlpha'} contentBackgroundColor={isEmbeddedMode ? 'white' : 'darkMode.500'} defaultFilterValue={selectedOption} filterOptions={filterOptions} getValueFromOption={opt => opt.value} hasDateRange={false} iconColor={isEmbeddedMode ? 'luigisPants.500' : 'white'} onFilterChange={handleFilterChange} /> : <CbSelect color={isEmbeddedMode ? 'text.primary' : 'white'} onChange={handleFilterChange} options={filterOptions} value={selectedOption} variant={isEmbeddedMode ? 'cb-input-outline' : 'cb-input-outlineWhite'} getValueFromOption={opt => opt.value} />}
        </Box>} data-sentry-element="CbColorBanner" data-sentry-component="Header" data-sentry-source-file="Header.tsx" />;
};